export const generalFaq = [
  {
    question: "What is Buddify?",
    answer:
      "Buddify is an AI-driven ecommerce platform that helps businesses sell more and grow together. Buddy AI helps shoppers with answers, recommendations, and offers. Brand Partnerships connects brands to source products, reach new retailers, and expand their catalogs.",
  },
  {
    question: "Do I need both apps?",
    answer:
      "No, you can use either app independently. However, they work beautifully together — expand your catalog with Brand Partnerships, then convert more visitors with Buddy AI Assistant.",
  },
  {
    question: "Is there a free plan?",
    answer:
      "Yes! Both apps offer ways to try them risk-free. The Brand Partnerships free plan lets you supply or import 5 products. The Buddy AI Assistant includes a 14-day free trial.",
  },
  {
    question: "How does the Buddy AI Assistant work?",
    answer:
      "The Buddy AI Assistant engages your visitors in natural conversations, answers product questions, and offers personalized discounts when they're hesitating. It works 24/7 to convert browsers into buyers.",
  },
];

export const brandPartnershipsFaq = [
  {
    question: "How do I find suppliers?",
    answer:
      "Once you install the app, you'll have access to our platform of verified brands. You can filter by category, location, price range, and more to find the perfect partners for your store.",
  },
  {
    question: "Who handles shipping?",
    answer:
      "The supplier handles all fulfillment. When you receive an order, it's routed to the supplier who ships directly to your customer. You can even use your own branding.",
  },
  {
    question: "Are there any transaction fees?",
    answer:
      "No! We don't charge any commissions or transaction fees for Suppliers and Retailers. You keep 100% of your profit margin. You only pay the monthly subscription fee based on your plan.",
  },
  {
    question: "Can I be both a supplier and retailer?",
    answer:
      "Absolutely! Many merchants use Buddify to both source products for their store AND sell their products to other stores. Our Buddy plan is designed specifically for this.",
  },
  {
    question: "What countries are supported?",
    answer:
      "We have suppliers and retailers in 25+ countries including USA, UK, Canada, Australia, and throughout the EU and Asia. Local suppliers mean faster shipping for your customers.",
  },
];

export const aiAssistantFaq = [
  {
    question: "How does the AI know about my products?",
    answer:
      "The AI automatically syncs with your store to learn about your products, prices, and inventory. Buddy AI also learns from additional information like shipping/returns policies and FAQs.",
  },
  {
    question: "What is AI-attributed sales?",
    answer:
      "When a customer purchases after interacting with the AI assistant, that sale is attributed to the AI. This helps you track how much revenue the AI is driving for your store.",
  },
  {
    question: "Can I customize the AI responses?",
    answer:
      "Yes! You can train the AI on your specific policies, tone of voice, and common questions.",
  },
  {
    question: "Will it work with my existing chat?",
    answer:
      "The Buddy AI Assistant is designed to be your primary customer engagement tool. It can work alongside other tools, but performs best as your main chat interface.",
  },
  {
    question: "What is exit intent?",
    answer:
      "Exit intent detects when a visitor is about to leave your site (moving mouse toward close button, switching tabs, etc.) and triggers a smart offer to keep them engaged.",
  },
];
